import React from 'react';
import PropTypes from 'prop-types';

// Import components
import { PlayerElements as Player } from 'components/elements';
import PlayerErrorContent from './PlayerErrorContent';

// Import utilities
import { useUserSourceType } from 'components/utilities';

// Import helpers
import { ERROR_CODE_API_TYPES } from 'helpers/error_code_api';

const { RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS } = ERROR_CODE_API_TYPES;

const PlayerError = ({ error: { message, errorCode = '' }, playerType }) => {
	const { isNexGenUser } = useUserSourceType();

	const hideErrorMessage =
		isNexGenUser && errorCode === RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS;

	return (
		<Player.Error>
			<Player.ErrorContent>
				{!errorCode && <Player.IconPortal />}

				{!hideErrorMessage && (
					<>
						<Player.IconLock />
						<Player.ErrorHeading>{message}</Player.ErrorHeading>
					</>
				)}
				<PlayerErrorContent
					errorCode={errorCode}
					playerType={playerType}
					message={message}
				/>
			</Player.ErrorContent>
		</Player.Error>
	);
};

PlayerError.propTypes = {
	error: PropTypes.shape({ message: PropTypes.string }).isRequired,
	playerType: PropTypes.string
};

export default PlayerError;
